import React from 'react'
import StructuredData from './StructuredData'
import { getCustomImage } from '../helpers'
import { stripHtml } from '../../api'
import mapSocialAccounts from './helpers'

export const getPersonData = (data) => {
  return {
    '@type': 'Person',
    name: data.name,
    image: getCustomImage(data),
    description: stripHtml(data.biography),
    jobTitle: data.title ? data.title : undefined,
    url: data.url,
    sameAs: data.socialAccounts ? mapSocialAccounts(data.socialAccounts, false) : undefined,
    honorificPrefix: data.honors ? data.honors : undefined,
    // TODO: need BSP company field to be a lookup and not a string
    // worksFor: getOrganizationData(data.company),
  }
}

export default function PersonStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getPersonData(data)
  return <StructuredData data={structuredData} dataTestId="person-structured-data" />
}
